<template>
  <v-container class="fullwidth nopadding">
    <!-- PROJECT TABLE -->
    <v-data-table v-model="selectedProjects" :headers="headers" :items="projects" :single-select="false" item-key="id"
      show-select class="elevation-1">
      <!-- ***** FILTROS ***** -->
      <template v-slot:top>
        <v-container class="nonothing fullwidth">
          <v-row>
            <v-col>
              <!-- filtro por status -->
              <strong class="d-flex flex-row">Buscar por status:</strong>
              <div id="filter-by-status" class="d-flex flex-row">
                  <div class="item-status-filter" v-for="statusItem in statusFilterDetail" :key="statusItem.value">
                    <v-checkbox v-model="statusFilterInput" :value="statusItem.value"></v-checkbox>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="icon-filter-status" v-bind="attrs" v-on="on" :color="statusItem.color">
                          {{ statusItem.icon}}
                        </v-icon>
                      </template>
                      <span>{{ statusItem.label }}</span>
                    </v-tooltip>
                  </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <!-- filtro nome empreendedor -->
              <strong class="d-flex flex-row">Buscar por empreendedor:</strong>
              <div class="d-flex flex-row">
                <v-autocomplete v-model="entrepreneurFilterInput" :items="entrepreneurNames"
                  label="Digite/Selecione o nome" variant="outlined" multiple outlined dense chips small-chips></v-autocomplete>
              </div> <!-- END filtro nome empreendedor -->
            </v-col>

            <v-col>
              <!-- filtro por tag -->
              <strong class="d-flex flex-row">Buscar por tag:</strong>
              <div class="d-flex flex-row" v-bind="tags" cols="4">
                <v-autocomplete v-model="tagFilterInput" :items="tags" item-value="name" item-text="name"
                  item-color="color" label="Digite/Selecione a tag" variant="outlined" multiple outlined dense chips small-chips>
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected"
                      :color="(data.item && data.item.color) ? data.item.color : ''" small>
                      <v-sheet :color="(data.item && data.item.color) ? data.item.color : ''">
                        {{ (data.item && data.item.name) ? data.item.name : '' }}
                      </v-sheet>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </div> <!-- END filtro por tag -->
            </v-col>
          </v-row>
        </v-container>
      </template>
      <!-- END ***** FILTROS ***** -->

      <!-- ***** CUSTOM COLUMNS ***** -->

        <!-- STATUS COLUMN -->
        <template v-slot:[`item.status`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, showStatusDescription }">
              <v-icon v-if="statusDetailsForColumns[item.status]" class="icon-filter-status" v-bind="showStatusDescription" v-on="on" :color="statusDetailsForColumns[item.status].color">
                {{ statusDetailsForColumns[item.status].icon }}
              </v-icon>
            </template>
            <span>{{ statusDetailsForColumns[item.status] ? statusDetailsForColumns[item.status].label : "-" }}</span>
          </v-tooltip>
        </template>
        <!-- END STATUS COLUMN -->

        <!-- TAG COLUMN -->
        <template v-slot:[`item.tags`]="{ item }">
          <v-sheet v-if="item.tags">
            <v-tooltip top v-for="tag in item.tags" :key="tag.id">
              <template v-slot:activator="{ on, showStatusName }">
                <v-chip x-small v-bind="showStatusName" v-on="on" :color="(tag && tag.color) ? tag.color : ''"
                  class="pl-3 pr-3 pt-1 pb-1"></v-chip>
              </template>
              <span>{{ (tag && tag.name) ? tag.name : '---' }}</span>
            </v-tooltip>
          </v-sheet>
        </template>
        <!-- END TAG COLUMN -->

        <!-- PROJECT COLUMN -->
        <template v-slot:[`item.nameOfProject`]="{ item }">
          {{ item.nameOfProject ? item.nameOfProject : '---' }}
        </template>
        <!-- END PROJECT COLUMN -->

        <!-- ENTREPRENEUR COLUMN -->
        <template v-slot:[`item.entrepreneur`]="{ item }">
          {{ item.entrepreneur.name ? item.entrepreneur.name : '---' }}
        </template>
        <!-- END ENTREPRENEUR COLUMN -->

        <!-- ACTION COLUMN -->
        <template v-if="type === 'ACTION_TABLE'" v-slot:[`item.action`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="actionDetails" v-bind="attrs" v-on="on" :color="actionDetails.color" @click="onAction( item.id )">
                {{ actionDetails.icon }}
              </v-icon>
            </template>
            <span>{{ actionDetails.label }}</span>
          </v-tooltip>
        </template>
        <!-- END ACTION COLUMN -->

      <!-- END ***** CUSTOM COLUMNS ***** -->
    </v-data-table>

    <!-- CARD FOOTER -->
    <v-card-actions v-if="btnText" v-show="btnText">
      <v-btn :color="buttonColor" type="buttom" @click="onClick">{{ btnText }}</v-btn>
    </v-card-actions>
    <!-- END CARD FOOTER -->

  </v-container>
</template>

<script>
  import oppotunityStatusIcons from '@/const/project/opportunityStatusIcons.js';
  import oppotunityStatusIconsForColumns from '@/const/project/opportunityStatusIconsForColumns.js';

  export default {
    name: 'OpportunityProjectTable',
    props: [
      "type", // (ACTION_TABLE|VOTING_SHOWCASE|VOTING_PORTAL) - To control columns
      'title', // String,
      'projects', // [],
      'tags', // [{id, name, color}]
      'action', // String,
      'btnText', // String,
    ],
    data: () => ({
      selectedProjects: [], // Receives the checkbox-selected projects
      // ↓↓ Filters ↓↓
      statusFilterDetail: [], // status with icon included
      statusFilterInput: [],
      tagFilterInput: [],
      entrepreneurFilterInput: '',
      // ↓↓ custom columns ↓↓
      statusDetails: oppotunityStatusIcons,
      statusDetailsForColumns: oppotunityStatusIconsForColumns,
      actionDetails: {
        color: null,
        label: null,
        icon: null
      },
      buttonColor: '',
    }),
    computed: {
      headers() {
        let h = [{
          text: "Status",
          align: "center",
          value: "status",
          filter: this.statusFilter,
        }, {
          text: "Tags",
          value: "tags",
          filter: this.tagFilter,
        }, {
          text: "Proposta",
          value: "nameOfProject",
        }, {
          text: "Empreendedor",
          value: "entrepreneur",
          filter: this.entrepreneurFilter
        }]

        if (!this.type)
          return h;
        if (this.type == 'ACTION_TABLE') {
          const actionColumn = {
            text: "",
            value: "action",
          };
          h.push(actionColumn);
        } else if (this.type == 'VOTING_PORTAL') {
          h.push({
            text: "Votos",
            value: "totalVotes"
          });
          h.push({
            text: "Último voto",
            value: "lastDateVoteAt"
          });
        } // if( type === 'VOTING_SHOWCASE' )
        return h;
      },
      entrepreneurNames() {
        if (!this.projects || this.projects.length === 0)
          return [];
        const entrepreneurs = this.projects.map(project => project.entrepreneur ? project.entrepreneur.name : '');
        return [...new Set(entrepreneurs)] // get unique names of entrepreneurs
      }
    },
    beforeMount() {
      this.statusFilterDetail = Object.keys(oppotunityStatusIcons).map((key) => {
        return oppotunityStatusIcons[key]
      });
    },
    mounted() {
      // Define actions and button color
      if (this.action === 'add') {
        this.actionDetails.color = 'success';
        this.actionDetails.label = 'Adicionar à votação';
        this.actionDetails.icon = 'add';
        this.buttonColor = 'success'
      } else if (this.action === 'remove') {
        this.actionDetails.color = 'red';
        this.actionDetails.label = 'Remover da votação';
        this.actionDetails.icon = 'clear';
        this.buttonColor = 'red'
      }
    },
    methods: {
      tagFilter(projectTags) {
        if (!this.tagFilterInput || this.tagFilterInput.length === 0)
          return true;
        if (!projectTags || projectTags.length === 0)
          return false; // Returning false, cause tagFilterInput is not empty

        const result = projectTags.filter(tag => {
          return this.tagFilterInput.filter(tagInput => tagInput === tag.name).length > 0;
        }).length > 0;
        return result
      },
      statusFilter(projectStatus) {
        let status = projectStatus === null ? 'null' : projectStatus
        status = status === 'aprovada' ? 'proposta_aprovada' : status

        // TODO: Include progres
        if (!this.statusFilterInput || this.statusFilterInput.length === 0)
          return true
        if (!status)
          return false
        if (this.statusFilterInput.includes(status))
          return true
        return false
      },
      entrepreneurFilter(projectEntrepreneur) {
        if (!this.entrepreneurFilterInput || this.entrepreneurFilterInput.length === 0)
          return true;
        if (!projectEntrepreneur || projectEntrepreneur.length === 0 || !projectEntrepreneur.name)
          return false; // It has a search sat, but project entrepreneur is empty

        return this.entrepreneurFilterInput.filter(
          entrepreneurFilterName => projectEntrepreneur.name === entrepreneurFilterName
        ).length > 0;
      },
      onClick() {
        const projectIds = this.selectedProjects.map(project => project.id);
        this.selectedProjects = [];
        this.$emit('btnClicked', projectIds);
      },
      onAction(projectId) {
        this.$emit('triggerAction', [projectId]);
      }
    }
  }
</script>

<style scoped>
  .fullwidth {
    max-width: 100%;
    width: 100%;
  }

  .nonothing {
    margin: 0 !important;
    padding: 0 !important;
  }

  .item-status-filter {
    display: flex;
    min-width: 70px;
    max-width: 60px;
    padding: 0;
  }

  .icon-filter-status {
    margin-top: -2px !important;
  }

  #filter-by-status {
    margin-top: -12px;
  }

  .v-data-table.elevation-1.theme--light {
    box-shadow: none !important;
  }

  .theme--light.v-sheet {
    /* background-color: transparent; */
    border-color: initial;
    color: initial;
  }

  .v-chip.v-size--x-small {
    border-radius: 12px;
    font-size: 10px;
    height: 10px;
    width: 30px;
    margin: 0 6px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/project/OpportunityProjectTable.vue